import React from "react";
import { Link } from "react-router-dom";

const ForbiddenPage = () => {
  return (
    <div className="text-center mt-5">
      <h1>403</h1>
      <h3>Accesso non autorizzato</h3>
      <p>Non hai i permessi per accedere a questa pagina.</p>
      <Link to="/" className="btn btn-primary mt-3">
        Torna alla dashboard
      </Link>
    </div>

  );
};

export default ForbiddenPage;